import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr'
import { HttpClient } from '@angular/common/http';
import { MessageDto } from '../dto/MessageDto';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

// import { MessagesComponent } from 'src/app/management/pages/messages/messages.component';
// import { InternalService } from './internal.service';
import { ApiService } from './api.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { IChatMessage } from '../interfaces/chatMessage';
// import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private _massageCount = new BehaviorSubject<any>(null);
  msgCount: any = null;

  roles: any = [];

  public chatList: any = [];
  public roomList: any = [];

  public _userMessageHistorySubject= new BehaviorSubject<any[]>([]);
  public userMessageHistory: any = [];
  get userMessageHistorySubject(): Observable<any[]> { return this._userMessageHistorySubject.asObservable() }

  public _userListMessageSubject= new BehaviorSubject<any[]>([]);
  public userListMessage: any = [];
  get userListMessageSubject(): Observable<any[]> { return this._userListMessageSubject.asObservable() }
  

  // public loginToken : any = this.oidcSecurityService.getAccessToken().subscribe((token) => {
  //   return token;
  // });

 
  

  private connection: any = new signalR.HubConnectionBuilder()
     .withUrl('https://app.ostadvisit.com/chatHub',  
      // {
      //   transport: signalR.HttpTransportType.WebSockets
      // },
    { 
      accessTokenFactory: async () =>
         {
           const token = await this.oidcSecurityService
           .getAccessToken()
           .toPromise(); return token ?? ''; 
          } ,
          transport: signalR.HttpTransportType.WebSockets | 
          signalR.HttpTransportType.ServerSentEvents | 
          signalR.HttpTransportType.LongPolling  // Allow all transports
    }
  )
    .configureLogging(signalR.LogLevel.Information)
    // .withAutomaticReconnect()
    .build();

  

  readonly POST_URL = ""

  private receivedMessageObject: MessageDto = new MessageDto();
  public sharedObj = new Subject<MessageDto>();


  constructor(private http: HttpClient,
              private apiService: ApiService,
              private oidcSecurityService: OidcSecurityService,
              // private cookieService: CookieService,
              // public internalService: InternalService
            ) {
    this.connection.onclose(async () => {
      await this.start();
    });

    this.connection.on("ConnectionStatus", (res: any) => {
      console.log('connection:', res)
      
      // this.mapReceivedMessage(user, message); 

    })


    this.start();


    // this.apiService.apiCall('get', '/api/admin/NewMessageCount', {}).subscribe((res: any) => {      
    //   this.msgCount = res.res;
    //   // console.log('+-*-/+*/', this.msgCount)
    //   this.populateMessageCount(this.msgCount);
    // })

    // this.oidcSecurityService.getAccessToken().subscribe(token => console.log("Access Token:", token));

    
    
  }


  ////////////// start the connection
  public async start() {
    try {
      await this.connection.start();
      console.log("connected");
      
    } catch (err) {
      console.log('///////////////',err);
      setTimeout(() => this.start(), 5000);
    }
  }

  private mapReceivedMessage(user: string, message: string): void {
    this.receivedMessageObject.user = user;
    this.receivedMessageObject.msgText = message;
    this.sharedObj.next(this.receivedMessageObject);
  }


  // ---------------------------------- Messages -------------------------------------

  public sendMessage(visitId: number, message: string, sendTime: string) {
    this.connection.invoke("SendMessage", Number(visitId), message).catch(err => console.log('||||||||',err))
    console.log('successful')
  }

  public recieveRoom() {
    this.connection.on("UpdateRoom", (res: any) => {
      console.log('room:', res);
      // this.roomList = res;
      // if (this.roomList.userprofilepic) {
      //   this.internalService.getMd5(this.roomList.userprofilepic).then(result => {
      //     this.roomList.base64 = result;
      //   });
      // }
      // if (this.userListMessage.indexOf(this.roomList) === -1) {
        // this.userListMessage.splice(0,0,this.roomList);
      // }
      
      // this._userListMessageSubject.next(this.userListMessage);      
    })
  }

  public recieveMessages() {
      return this.connection.on("ReceiveMessage", (res: any, userId: any) => {
      
      // this.roles = JSON.parse(this.cookieService.get('currentUserRoles'));
      // if(this.roles == 'Admin' || this.roles == 'Administrator'){
      //   this.apiService.showMessage('Message.YouHaveNewMessage', 1);
      // }

      console.log('message:', res);
      this.chatList = res;
      this.userMessageHistory.push(this.chatList);
      this._userMessageHistorySubject.next(this.userMessageHistory)
        // if (this.userMessageHistory.type == 2) {
        //   // this.internalService.getMd5(this.userMessageHistory.message).then(result => this.userMessageHistory.message = result)
        // }
      
    });
  }


  //--------------------------------- public methods -----------------------------------

  // calls the controller method
  public broadcastMessage(msgDto: any) {
    // this.http.post(this.POST_URL, msgDto).subscribe(data => console.log(data));
    this.connection.invoke("ConnectToServer", this.receivedMessageObject.user).catch(err => console.error(err));
    console.log(this.receivedMessageObject.user)

  }

  public retrieveMappedObject(): Observable<MessageDto> {
    return this.sharedObj.asObservable();
  }




  ////////////////////// message count

  getMessageCount$(): Observable<any> {
    return this._massageCount.asObservable();
  }

  populateMessageCount(num: any): void {
    this._massageCount.next(num);
  }

}
